module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDYuNjY2NjdWMTBMMTIuNSAxMi41TTE3LjUgMTBDMTcuNSAxNC4xNDIyIDE0LjE0MjIgMTcuNSAxMCAxNy41QzUuODU3ODcgMTcuNSAyLjUgMTQuMTQyMiAyLjUgMTBDMi41IDUuODU3ODcgNS44NTc4NyAyLjUgMTAgMi41QzE0LjE0MjIgMi41IDE3LjUgNS44NTc4NyAxNy41IDEwWiIgc3Ryb2tlPSIjMkUzNjQ2IiBzdHJva2Utd2lkdGg9IjEuNjY2NjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/clock.svg
// module id = ZuxU
// module chunks = 0